import React from 'react';

export const Marker = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17"><circle cx="511.2" cy="308.4" r="7.2" transform="translate(-502 -300)" fill="#2A312E" stroke="#FFF" strokeWidth="2.4" fillRule="evenodd"/></svg>
    )
};

export const ComingSoonMarker = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18"><circle cx="501.6" cy="337.2" r="7.2" transform="translate(-493 -328)" fill="#A2A39A" stroke="#FFF" strokeWidth="2.4" fillRule="evenodd"/></svg>
    )
}

export const SoldMarker = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18"><circle cx="669.6" cy="334.8" r="7.2" transform="translate(-661 -326)" fill="#A63E3E" stroke="#FFF" strokeWidth="2.4" fillRule="evenodd"/></svg>
    )
}

export const MinusIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="2"><path fill="#2A312E" d="M0 0h16v2H0z" fillRule="evenodd"/></svg>
    )
}

export const PlusIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M16 7H9V0H7v7.001L0 7v2l7 .001V16h2V9h7V7z" fill="#2A312E" fillRule="evenodd"/></svg>
    )
}